<template>
  <PesquisaConcluido v-if="concluido" @close="emits('close')" />
  <div
    class="form-pesquisa-antecipa-popup-wrapper"
    v-else
    style="
      height: 100%;
      width: auto;
      overflow-y: auto;
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding: 0 1.3rem;
      gap: 1.8rem;
    "
  >
    <div
      class="form-pesquisa-antecipa-popup-top"
      style="
        text-align: center;
        font-size: 24px;
        font-weight: 300;
        font-style: Light;
        line-height: 150%;
        letter-spacing: 0%;
        z-index: 1;
      "
    >
      Como você lida com os desafios de
      <b style="font-weight: 700">Fluxo de Caixa</b> da sua empresa?
    </div>
    <div
      class="form-pesquisa-antecipa-popup-middle"
      style="padding: 0px 1.7rem"
    >
      <el-form style="padding: 0">
        <div>
          <el-config-provider namespace="financas">
            <el-radio-group
              v-model="tipo"
              style="
                display: flex;
                flex-direction: column;
                align-items: flex-start;
              "
              :style="{ gap: gapIsHorizons }"
            >
              <el-radio
                v-for="tipo in tiposOpt"
                :key="tipo.value"
                :label="tipo.value"
                :value="tipo.value"
                style="gap: 6px; display: flex"
              >
                <span
                  style="
                    padding: 0;
                    font-size: 12px;
                    font-weight: 400;
                    line-height: 16px;
                    color: #4f4f4f;
                  "
                  >{{ tipo.label }}</span
                ></el-radio
              >
            </el-radio-group>
          </el-config-provider>

          <el-form>
            <el-form-item v-if="tipo === '5'" prop="descricao">
              <vc-input
                v-model="form.descricao"
                type="textarea"
                resize="none"
                :rows="2"
                prop="descricao"
                placeholder="Digite aqui"
                style="width: 100%; height: 50px"
                ref="vcInputRef"
              />
            </el-form-item>
          </el-form>
        </div>
      </el-form>
    </div>
    <div
      class="form-pesquisa-antecipa-popup-bottom"
      style="display: flex; justify-content: center"
    >
      <vc-button
        size="large"
        filled
        @click="enviar"
        :disabled="disableEnvio"
        :is-loading="loading"
        style="width: 177px; height: 46px"
      >
        <span style="font-size: 20px">Enviar</span></vc-button
      >
    </div>
  </div>
</template>

<script setup lang="ts">
import PesquisaConcluido from "../components/PesquisaConcluido.vue";
import { computed, ref, watch } from "vue";

const tipo = ref("");

const vcInputRef = ref<any>();

defineProps<{
  concluido: boolean;
  loading: boolean;
}>();

const emits = defineEmits<{
  (e: "enviar", form: unknown): void;
  (e: "close"): void;
}>();

const currentPath = window.location.href;
const isHorizons = currentPath.includes("/v2/") || currentPath.includes("/#/");

const gapIsHorizons = computed(() => (isHorizons ? "15px" : "25px"));

const tiposOpt = [
  {
    label: "Utilizo reservas financeiras próprias",
    value: "1"
  },
  {
    label: "Adio pagamentos ou renegocio os prazos",
    value: "2"
  },
  {
    label: "Recorro a antecipação dos recebíveis de cartão",
    value: "3"
  },
  {
    label: "Não tenho problemas de Fluxo de Caixa",
    value: "4"
  },
  {
    label: "Outro",
    value: "5"
  }
];

const form = ref({
  tipo: "",
  descricao: ""
});

watch(
  () => vcInputRef.value?.vcModelValue,
  (newValue: any) => {
    if (newValue !== undefined) {
      form.value.descricao = newValue;
    }
  },
  { immediate: true }
);

const disableEnvio = computed(
  () => !tipo.value || (tipo.value === "5" && !form.value.descricao)
);

watch(tipo, (newValue: string) => {
  form.value.tipo = newValue;
  if (newValue !== "5") {
    form.value.descricao = "";
  }
});

const enviar = async () => {
  if (disableEnvio.value) return;

  emits("enviar", {
    value: {
      tipo: form.value.tipo,
      descricao: form.value.descricao
    }
  });
};
</script>

<style lang="scss">
@use "@/ui/styles/variables" as *;
@use "@/ui/styles/theme/f360-theme" as *;
@use "element-plus/theme-chalk/el-radio-group.css";
@use "element-plus/theme-chalk/el-radio.css";
@use "element-plus/theme-chalk/el-input.css";

.form-pesquisa-antecipa-popup-wrapper {
  height: 100%;
  width: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0 2rem;
  gap: 1rem;

  &-top {
    font-weight: 300;
    font-style: Light;
    font-size: 24px;
    line-height: 150%;
    letter-spacing: 0%;
    text-align: center;
    vertical-align: middle;
    b {
      font-weight: 700;
    }
  }

  &-bottom {
    .el-button {
      height: 38px;
      width: 177px;
      border-radius: 5px;
      gap: 0px;

      .el-button__label {
        font-size: 20px;
      }
    }
  }

  .financas-radio {
    gap: 8px !important;

    &__inner {
      border-color: #4f4f4f !important;
      background-color: transparent !important;

      &::after {
        background-color: #0055ff !important;
        width: 10px !important;
        height: 10px !important;
      }
    }

    &__label {
      padding: 0;
      font-family: $fontFamily !important;
      font-size: 12px !important;
      font-weight: 400 !important;
      line-height: 16px !important;
      color: #4f4f4f !important;
    }
  }
}
</style>
